import React, { useEffect } from 'react'
import { DEFAULT_IMAGE_400 } from "../../middleware/types";
import useStateRef from 'react-usestateref';

const ProductModal = (props) => {

    const [productImage, setProductImage, productImageRef] = useStateRef()

    function imageZoomed() {
        const target = document.getElementById("imgZoom")
        const imgZoomDiv = document.getElementById("imgZoomDiv")
      
        if (target.classList.contains("zoomed")) {
            imgZoomDiv.style.backgroundImage = `url()`;
            target.classList.remove('zoomed')
            // imgZoomDiv.classList.remove('zoomed')
        } else {
            let src = target.getAttribute("src");
            imgZoomDiv.style.backgroundImage = `url(${src})`;
            target.classList.add('zoomed')
            // imgZoomDiv.classList.add('zoomed')
			target.addEventListener("mousemove", function (event) {
				zoomIn(event);
			});
			target.addEventListener("mouseleave", function (event) {
				zoomOut(event);
			});
		
        }
    }

    function zoomIn(e) {
        const target = document.getElementById("imgZoom")
        const imgZoomDiv = document.getElementById("imgZoomDiv")
		e.preventDefault();
		let offsetX;
		let offsetY;
		let img = e.target.src;
        // imgZoomDiv.style.backgroundImage = `url(${img})`;
		e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
		e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
		let x = offsetX / imgZoomDiv.offsetWidth * 100;
		let y = (offsetY / imgZoomDiv.offsetHeight * 100);
		// imgZoomDiv.style.backgroundPosition = x+'%' + y + '%'

	}



	function zoomOut(e) {
        const target = document.getElementById("imgZoom")
        const imgZoomDiv = document.getElementById("imgZoomDiv")
        // imgZoomDiv.style.backgroundImage = `url()`;
		// imgZoomDiv.style.backgroundPosition = ""
		
	}
    useEffect(() => {
        document.querySelector('#productImage').addEventListener('hidden.bs.modal', function (e) {
            const target = document.getElementById("imgZoom")
            const imgZoomDiv = document.getElementById("imgZoomDiv")
            target.classList.remove('zoomed');
            imgZoomDiv.classList.remove('zoomed');

        })


    }, [])

    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_400;

    }


    return (
        <div>
           
                <div id="productImage" class="modal fade " data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <img fetchpriority="high" id="blurImage" onError={replaceImage} src={props.domainName.concat(props.productImage)} data-bs-dismiss="modal" />
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" style={{ right: "0", position: "absolute", width: "60px", height: "60px" }} class=" mz-button mz-button-close"></button>
                    <div class="modal-dialog">
                        <div class="modal-content" style={{ backgroundColor: "black", border: "none" }} id="imgZoomDiv">
                            <img fetchpriority="high" alt={props.domainName.concat(props.productImage)} id="imgZoom" onError={replaceImage} onClick={() => imageZoomed()} class="modal-body p-0 imagepointer" src={props.domainName.concat(props.productImage)} />
                        </div>
                    </div>


                </div> 
        </div>
    )
}

export default ProductModal